import * as actionType from '../action-type';

export const updateHardSurfaceBasicReport = (data) => ({
  type: actionType.UPDATE_HARD_SURFACE_BASIC_REPORT,
  payload: data,
});

export const resetHardSurfaceBasicReport = () => ({
  type: actionType.RESET_HARD_SURFACE_BASIC_REPORT,
});